import * as Sentry from "@sentry/browser"

export const setupErrorLogging = () => {
  if (import.meta.env.PUBLIC_HP_ENV === "production") {
    Sentry.init({
      dsn: "https://64089106ad05d281037af5c2f1ccd315@o962485.ingest.sentry.io/4505782152462336",
      integrations: [
        new Sentry.BrowserTracing({
          // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
          tracePropagationTargets: ["localhost", "https:yourserver.io/api/"],
        }),
        new Sentry.Replay(),
      ],
      // Performance Monitoring
      tracesSampleRate: 0.01, // Capture 100% of the transactions, reduce in production!
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })
  }
}

export const captureException = async (error: any) => {
  if (import.meta.env.PUBLIC_HP_ENV === "production") {
    Sentry.captureException(error)
  }
}

export default captureException
